var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"mediacontact-partner-category-create","title":"Media Kategorie erstellen","width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('mediacontact-partner-category-form',{attrs:{"mediacontactPartnerCategory":_vm.mediacontactPartnerCategory,"type":"create"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }